import { Card, CardBody, Tab, Tabs } from '@nextui-org/react';
import { Key } from 'react';
import ChatListClients from './ChatListClients';
import ChatListActors from './ChatListActors';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  selectChatMode,
  setChatMode,
} from '../../store/settings/settingsSlice';
import { selectUserRole } from '../../store/auth/authSlice';
import ChatListCustomActors from './ChatListCustomActors';

export default function ChatList() {
  const dispatch = useAppDispatch();
  const chatMode = useAppSelector(selectChatMode);
  const userRole = useAppSelector(selectUserRole);
  const handleSetChatMode = (key: Key) => {
    // @ts-ignore: key is always of type ChatMode
    dispatch(setChatMode(key));
  };

  return (
    <Card className="flex w-full m-2">
      <CardBody className="relative px-2 py-0">
        <div className="sticky top-0 w-full z-20 chat-list-tabs">
          <div className="relative my-2 w-fit max-w-full border-1 rounded-full backdrop-blur-md">
            <Tabs
              color="primary"
              radius="full"
              variant="light"
              aria-label="Chat switcher"
              selectedKey={chatMode}
              onSelectionChange={handleSetChatMode}
              className="opacity-100 max-w-full client-actor"
            >
              {userRole !== 'user_trainee' && (
                <Tab key="clients" title="Clients (Human)" />
              )}
              <Tab key="actors" title="Actors (AI)" />
              {process.env.REACT_APP_DEPLOYMENT_TYPE !== 'SOS' &&
                userRole !== 'user_trainee' && (
                  <Tab key="custom-actors" title="Your Actors" />
                )}
            </Tabs>
          </div>
        </div>
        {chatMode === 'clients' && <ChatListClients />}
        {chatMode === 'actors' && <ChatListActors />}
        {chatMode === 'custom-actors' && <ChatListCustomActors />}
      </CardBody>
    </Card>
  );
}
